module.exports = __webpack_public_path__ + "static/media/29BDOS21.18ea1bc0.jpg";